import React, { useRef, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CircularProgress from '@material-ui/core/CircularProgress';

const LineChart = ({ options, loading }) => {
  const chartElem = useRef(null);
  useEffect(() => {
    const { chart } = chartElem.current;
    loading ? chart.showLoading('... در حال بارگیری') : chart.hideLoading();
  }, [loading]);
  return (
    <div>
      <HighchartsReact
        ref={chartElem}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

export default React.memo(LineChart);
